module.exports = "img/flags/YT.6a918cf.png";